import React from 'react';
import { FileIcon } from 'elements/Icon';

const PDF = () => (
  <FileIcon>
    <path d="M98,2v136H2V2H98 M100,0H0v140h100V0L100,0z"/>
    <g>
      <rect x="12.75" y="24" width="74" height="4"/>
      <rect x="12.75" y="36" width="74" height="4"/>
      <rect x="12.75" y="48" width="74" height="4"/>
      <rect x="12.75" y="60" width="74" height="4"/>
      <rect x="12.75" y="72" width="74" height="4"/>
      <rect x="12.75" y="84" width="54" height="4"/>
    </g>
    <rect x="12.916" y="102.748" width="74" height="24"/>
    <g>
      <path fill="#FFFFFF" className="text" d="M32.365,119.17h2.367v2.336h-2.367V119.17z"/>
      <path fill="#FFFFFF" className="text" d="M44.76,116.521c-0.674,0.562-1.637,0.844-2.888,0.844h-2.397v4.141h-2.391V109.99h4.944
        c1.14,0,2.049,0.297,2.727,0.891s1.017,1.513,1.017,2.758C45.771,114.998,45.435,115.959,44.76,116.521z M42.924,112.373
        c-0.305-0.255-0.731-0.383-1.281-0.383h-2.168v3.391h2.168c0.55,0,0.977-0.138,1.281-0.414s0.457-0.714,0.457-1.312
        S43.229,112.628,42.924,112.373z"/>
      <path fill="#FFFFFF" className="text" d="M54.449,110.24c0.808,0.266,1.462,0.753,1.962,1.461c0.401,0.573,0.675,1.192,0.821,1.859
        c0.146,0.667,0.219,1.302,0.219,1.906c0,1.531-0.308,2.828-0.923,3.891c-0.834,1.433-2.121,2.148-3.862,2.148h-4.965V109.99h4.965
        C53.38,110.001,53.975,110.084,54.449,110.24z M50.037,111.99v7.516h2.223c1.137,0,1.93-0.56,2.378-1.68
        c0.245-0.614,0.368-1.347,0.368-2.195c0-1.172-0.184-2.071-0.552-2.699s-1.1-0.941-2.194-0.941L50.037,111.99L50.037,111.99z"/>
      <path fill="#FFFFFF" className="text" d="M59.256,110.006h8.211v2.023h-5.82v2.648h5.102v2h-5.102v4.828h-2.391V110.006z"/>
    </g>
  </FileIcon>
);

export default PDF;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/PDF.jsx